define('KlaviyoNewsletter.View', [
  'klaviyonewsletter.tpl',
  'Backbone',
  'jQuery'
], function KlaviyoNewsletterView(
  Template,
  Backbone,
  jQuery
) {
  'use strict';

  return Backbone.View.extend({
    template: Template,

    initialize: function initialize(options) {
      this.configuration = options.configuration;
      this.userProfile = options.profile;
      var $afterViewRender = this.on('afterViewRender');
      var $afterGetScript = jQuery.getScript(this.configuration.subscriptionApiUrl);
      jQuery.when($afterViewRender, $afterGetScript).done(function () {
        _.defer(function () {
          /* eslint-disable */
          KlaviyoSubscribe.attachToForms('#email_signup', {
            hide_form_on_success: true,
            extra_properties: {
              $source: window.location.origin,
              $method_type: 'Klaviyo Form',
              $method_id: 'embed'
            }
          });
		  /* eslint-enable */
        });
      });
    },

    identifyMe: function identifyMe() {
      var nIntervId;

      if (!nIntervId) {
        nIntervId = setInterval(intervalTryToHide, 2);
      }

      function intervalTryToHide() {
        if (jQuery('#success_message_subscription').css('display') === 'block' || jQuery('.newsletter-suscription-form-input-custom').css('display') === 'none' || jQuery('.klaviyo_form_actions').css('display') === 'none') {
          jQuery('.newsletter-subscription-form-container, .newsletter-subscription-form-button-subscribe').css('display', 'none');
          clearInterval(nIntervId);
          return nIntervId;
        }
      }
    },

    events: {
      'click [data-action="addSuscriber"]': 'identifyMe'
    },

    getContext: function getContext() {
      return {
        configuration: this.configuration,
        userProfile: this.userProfile
      };
    }
  });

});
